// Allowlist of emails permitted to enable auto-run playbooks
export const AUTO_RUN_PLAYBOOK_ALLOWLIST: readonly string[] = [
  "amark@quotewell.com",
  "qw-submissions-internal@quotewell.com",
  "service@quotewell.com",
  "test@test.com",
];
